import React, { Component } from "react";

import { Metric } from "./../Utils/Utils.js";
import Heading from "./../Elements/Heading";

class MarqueeRenewalMetrics extends Component {
  render() {
    const { data } = this.props;

    return (
      <div className="row d-flex align-items-start">
        <div className="col-6 col-md-3 mb-3 mb-md-0">
          <Heading size={6} className={"mb-1"}>
            Recent Conversion Rate
          </Heading>

          <div className="d-flex">
            <Metric
              {...data.conversion_rate_recent}
              size={"lg"}
              type={"percentage"}
            />
          </div>

          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Monthly</h6>
            <Metric
              {...data.conversion_rate_recent_monthly}
              size={"xs"}
              type={"percentage"}
            />
          </div>
          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Annual</h6>
            <Metric
              {...data.conversion_rate_recent_annual}
              size={"xs"}
              type={"percentage"}
            />
          </div>
        </div>
        <div className="col-6 col-md-3 mb-3 mb-md-0">
          <Heading size={6} className={"mb-1"}>
            Subs up for Renewal (Rest of This Month)
          </Heading>

          <div className="d-flex">
            <Metric {...data.subs_rest_of_month} size={"lg"} />
          </div>

          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Monthly</h6>
            <Metric {...data.subs_rest_of_month_monthly} size={"xs"} />
          </div>
          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Annual</h6>
            <Metric {...data.subs_rest_of_month_annual} size={"xs"} />
          </div>
        </div>

        <div className="col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Predicted Conversion (Rest of This Month)
          </Heading>

          <div className="d-flex">
            <Metric {...data.conversion_rate_rest_of_month} size={"lg"} />
          </div>

          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Monthly</h6>
            <Metric
              {...data.conversion_rate_rest_of_month_monthly}
              size={"xs"}
            />
          </div>
          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Annual</h6>
            <Metric
              {...data.conversion_rate_rest_of_month_annual}
              size={"xs"}
            />
          </div>
        </div>
        <div className="col-6 col-md-3">
          <Heading size={6} className={"mb-1"}>
            Subs up for Renewal (Next Month)
          </Heading>

          <div className="d-flex">
            <Metric {...data.subs_next_month} size={"lg"} />
          </div>

          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Monthly</h6>
            <Metric {...data.subs_next_month_monthly} size={"xs"} />
          </div>
          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Annual</h6>
            <Metric {...data.subs_next_month_annual} size={"xs"} />
          </div>
        </div>

        <div className="col-6 col-md-3 mt-5">
          <Heading size={6} className={"mb-1"}>
            Predicted Conversion (Next Month)
          </Heading>

          <div className="d-flex">
            <Metric {...data.conversion_rate_next_month} size={"lg"} />
          </div>

          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Monthly</h6>
            <Metric {...data.conversion_rate_next_month_monthly} size={"xs"} />
          </div>
          <div className="d-flex justify-content-left align-items-center">
            <h6 className="mb-0 mr-2">Annual</h6>
            <Metric {...data.conversion_rate_next_month_annual} size={"xs"} />
          </div>
        </div>
      </div>
    );
  }
}

export default MarqueeRenewalMetrics;
